import React, { useState } from 'react';
import './TopicsList.css';

const TopicsList = ({ topics }) => {
  const [expandedTopics, setExpandedTopics] = useState(new Set());

  const toggleTopic = (topicName) => {
    setExpandedTopics(prev => {
      const newSet = new Set(prev);
      if (newSet.has(topicName)) {
        newSet.delete(topicName);
      } else {
        newSet.add(topicName);
      }
      return newSet;
    });
  };

  if (!topics || topics.length === 0) {
    return null;
  }

  return (
    <div className="topics-list">
      <h2>Topics ({topics.length})</h2>
      <div className="topics-container">
        {topics.map((topic, index) => (
          <div 
            key={index} 
            className={`topic-item ${expandedTopics.has(topic.topic) ? 'expanded' : ''}`}
          >
            <div 
              className="topic-header"
              onClick={() => toggleTopic(topic.topic)}
            >
              <i className={`fas fa-chevron-${expandedTopics.has(topic.topic) ? 'down' : 'right'}`}></i>
              <span className="topic-name">{topic.topic}</span>
              <span className="topic-message-count">
                {topic.messageCount} messages
              </span>
            </div>
            
            {expandedTopics.has(topic.topic) && (
              <div className="topic-details">
                <div className="detail-row">
                  <span className="detail-label">Schema:</span>
                  <span className="detail-value">{topic.schemaName}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Encoding:</span>
                  <span className="detail-value">{topic.messageEncoding}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Channel ID:</span>
                  <span className="detail-value">{topic.channelId}</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicsList;
